import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_ANALYTICS_GET',
  GET_SUCCESS: 'TEACHER_ANALYTICS_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_ANALYTICS_GET_FAILURE',
};

export const get = actions.get(
  (studentId, queryObj) =>
    `${BASE_URL}/intelanalytics/teacher-aggregate?${stringify(queryObj)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
